import { HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigurationService } from '@sondermind/configuration';

@Injectable({
  providedIn: 'root'
})
export class UrlTargetService {
  constructor(
    private configurationService: ConfigurationService
  ) {}

  targetsSonderMindApis(req: HttpRequest<unknown>): boolean {
    const { url } = req;
    const configEnv = this.configurationService.env;

    const bases = [
      configEnv.apiBase,
      configEnv.svcBase,
      configEnv.authBase,
      configEnv.notificationSvcBase,
      configEnv.proxyCommunicationSvcBase,
      configEnv.providerMetricsSvcBase,
      configEnv.miniformApiBase,
      configEnv.clinicalAssessmentsSvcBase,
      configEnv.clinicalInsightsSvcBase,
      configEnv.dataExchangeSvcBase,
      configEnv.schedulingSvcBase,
      configEnv.schedulingCoreSvcBase,
      configEnv.adminBase,
      configEnv.conciergeSvcBase,
      configEnv.engagementApiBase,
      configEnv.goalsSvcBase,
      configEnv.resourceSvcBase,
      configEnv.providerUiSvcBase,
      configEnv.contentSvcBase,
      configEnv.clientBillingUiSvcBase,
      configEnv.providerFaqResourceSvcBase,
      configEnv.smPubnubApiBase,
    ];

    return bases.some((base) => {
      if (!base) return false;

      try {
        const parsedUrl = new URL(url);
        const baseUrl = new URL(base);
        return parsedUrl.origin === baseUrl.origin;
      } catch {
        return url.startsWith(base);
      }
    });
  }
}
